import Server from "../server";
import View from "../framework/view";
import {Order} from "../bo/order";
import template from "../../pugc/print-orders";
import {customFieldsSorter, JsonDate, NOTE_TO_FLORIST} from "../misc/types";
import {toCanvas} from "qrcode";
import jQuery from "jquery";
import {format, parseISO} from "date-fns";
import {countLabels, getDeliveryCost, getOrderTimeInfo, highlightOption, isToPay, labelsRequired} from "../misc/orders";
import {renderDollars} from "../misc/utils";
import {CardNotification, PrintOrdersNotification} from "./wrb";
import {orderToCards} from "../misc/cards";
import { renderName } from "../shop/product";

type PrintFormat = "paper" | "label";

export class PrintOrdersView extends View {

    static classname = "print-orders-view";

    private readonly server = Server.instance();

    private ids : string[];

    private orders : Order[] = [];

    private selectedIds : { [id: string]: boolean} = {};

    private format : PrintFormat = "paper";

    private baseUrl?: string;

    constructor(ids: string[]) {
        super(PrintOrdersView.classname);
        this.ids = ids;
        this.refresh();
        this.server.getShortBaseUrl().then((url) => {
            this.baseUrl = url;
            this.update();
        });
    }

    refresh() {
        const q_ = this.server.getOrdersById(this.ids || []);

        q_.then((d) => {

            const byId : { [id: string]: Order} = {};
            d.forEach((o) => byId[o.id as string] = o);
            this.orders = this.ids.map((id) => byId[id]);
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        if (! this.baseUrl) {
            return jQuery("<div>Loading</div>");
        }

        const toQRCodeUrl = (qrcode_id: string) => `${this.baseUrl}#/qr/${qrcode_id}`;

        // Remove leading Add, trailing colon and capitalise first letter
        const prettyOption = (option: any) => {

            const sel = option.selection;
            if (sel.indexOf("Yes") == 0) {
                const str = option.option.replace(/^Add /, "").replace(/:$/, "");
                return str.charAt(0).toUpperCase() + str.slice(1);
            }

            // remove price
            const cleaned = sel.replace(/\$[0-9]+(\.[0-9]+)?\s*/, "");
            return cleaned;
        }

        const labelDate = (date: JsonDate) => {
            if (! date) {
                return "";
            }
            try {
                const d = parseISO(date);
                const s = format(d, "EEE dd/MM/yyyy");
                return s;
            } catch (err) {
                console.log("Failed to parse date", date, err);
                return date;
            }
        }

        const data = {
            orders: this.orders,
            order_ids: this.ids.join(","),
            selected: this.selectedIds,
            print_format: this.format,
            customFieldsSorter: customFieldsSorter,
            NOTE_TO_FLORIST: NOTE_TO_FLORIST,
            toQRCodeUrl: toQRCodeUrl,
            prettyOption: prettyOption,
            countLabels: countLabels,
            labelDate: labelDate,
            isToPay: isToPay,
            getDeliveryCost: getDeliveryCost,
            renderDollars: renderDollars,
            getOrderTimeInfo: getOrderTimeInfo,
            labelsRequired: labelsRequired,
            highlightOption: highlightOption,
            renderName: renderName
        };

        const out = this.pug(template, data);

        this.afterUpdate(() => {
            const width = this.elt().find(".qrcode").width();
            const canvases = this.elt().find("canvas");
            canvases.each((idx, c) => {
                const canvas = jQuery(c);
                const url = canvas.data("url");
                console.log("canvas width ", width);
                toCanvas(c, url, {
                    errorCorrectionLevel: "high",
                    width: width
                }, (err) => console.log(err))
            });
        });

        return out;
    }

    markAsPrinted() {
        const history = {
            "newStatus": "Printed"
        }
        const total = this.ids.length;
        let cnt = 0;

        for (const id of this.ids) {
            console.log("Marking " + id + " as printed");
            this.server.recordStatus(id, history).then(() => {
                cnt ++;
            });
        }

        window.history.back();
    }

    setFormat(format: PrintFormat) {
        this.format = format;
        this.update();
        window.print();
    }

    writeCards() {

        const filtered = this.orders.filter(o => {
            const cards = orderToCards(o);
            return cards.length > 0;
        });

        const ids = filtered.map(o => o.id as string);

        this.notify(new CardNotification(ids));
    }
}

View.on(
    "." + PrintOrdersView.classname,
    "click",
    ".mark-as-printed",
    function(that: PrintOrdersView, event, elt) {
        event.preventDefault();
        that.markAsPrinted();
    });

View.on(
    "." + PrintOrdersView.classname,
    "click",
    ".write-cards",
    function(that: PrintOrdersView, event, elt) {
        event.preventDefault();
        that.writeCards();
    });

View.on(
    "." + PrintOrdersView.classname,
    "click",
    ".select-print-format",
    function(that: PrintOrdersView, event, elt) {
        event.preventDefault();
        const format = jQuery(elt).data("format") as PrintFormat;
        that.setFormat(format);
    });

